'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'house';
var width = 512;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = 'M245.1 7.2c6.1-5.7 15.7-5.7 21.8 0L501.5 226.2c3.2 3 3.4 8.1 .4 11.3s-8.1 3.4-11.3 .4L464 213.1 464 456c0 30.9-25.1 56-56 56l-304 0c-30.9 0-56-25.1-56-56l0-242.9-26.5 24.8c-3.2 3-8.3 2.8-11.3-.4s-2.8-8.3 .4-11.3L245.1 7.2zM256 18.9L64 198.1 64 456c0 22.1 17.9 40 40 40l72 0 0-120c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 120 72 0c22.1 0 40-17.9 40-40l0-257.9-192-179.2zM192 496l128 0 0-120c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 120z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;